import { render, staticRenderFns } from "./CanvasDraw.vue?vue&type=template&id=8ad7c1f8&scoped=true"
import script from "./CanvasDraw.vue?vue&type=script&lang=js"
export * from "./CanvasDraw.vue?vue&type=script&lang=js"
import style0 from "./CanvasDraw.vue?vue&type=style&index=0&id=8ad7c1f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ad7c1f8",
  null
  
)

export default component.exports